import { render } from "./RiwayatSiswa.vue?vue&type=template&id=31e5d3c6"
import script from "./RiwayatSiswa.vue?vue&type=script&lang=js"
export * from "./RiwayatSiswa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__